import React, { useEffect, useState } from "react";
import Input from "../../form/Input";
import Button from "../../form/Button";
import Image from "../../elements/Image";
import Background from "../../../assets/image/background.jpg";
import Screenshot from "../../../assets/image/demo-screenshot.png";
import { postData } from "../../../services/api";
import toastr from "toastr";
import { Link } from 'react-router-dom';
import SchedualeDemoPopup from "../../popup/SchedualeDemoPopup";

const IntroContent = ({ type,segment }) => {
  const [loading, setLoading] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pageData, setPageData] = useState({});
  const [scheduleDemoPopup, setScheduleDemoPopup] = useState(false);
  const [firstChunk, setFirstChunk] = useState([]);
  const [secondChunk, setSecondChunk] = useState([]);
  const [chunkValue, setChunkData] = useState([]);
  const [lastchunkValue, setLastChunkData] = useState([]);
  const [pageData2, setPageData2] = useState({});
  const [pageData3, setPageData3] = useState({});
  const handelSubmit = async () => {
    setLoading(true);
    try {
      const result = await postData("/enquery/create", {
        type: 3,
        full_name: fullName,
        email: email,
        phone: phone,
        leadPath : segment
      });
      if (result.status === 200) {
        setLoading(false);
        setEmail("");
        setPhone("");
        setFullName("");
        toastr.success(result.message)
      } else {
        setLoading(false);
        toastr.error(result.message)
      }
    } catch (e) {
      setLoading(false);
      toastr.error(e.message)
    }
  };

  const chunk = (array, size) =>
    array.reduce((acc, _, i) => {
      if (i % size === 0) acc.push(array.slice(i, i + size))
      return acc
    }, [])

  useEffect(() => {
    const loadPageDetails = async () => {
      let slug = '';
      if (type === 2) {
        slug = 'intro2';
      } else if (type === 3) {
        slug = 'intro3';
      } else if (type === 4) {
        slug = 'succession-planing-intro4';
      }

      try {
        const result = await postData("/lead-content/details", {
          slug: slug
        });
        if (result.data) {
          if (Array.isArray(result.data.content)) {
            setPageData(result.data);
            const numbers = Array.isArray(result.data.content) && result.data.content;
            let chunked = result.data.content.slice(0, 3)
            let chunked2 = result.data.content.slice(3, 6)
            setFirstChunk(chunked)
            setSecondChunk(chunked2)
          }
          if (type === 4) {
            const result2 = await postData("/lead-content/details", {
              slug: 'business-intro4'
            });
            if (Array.isArray(result2.data.content)) {
              const numbers = result2.data.content
              const chunked3 = chunk(numbers, 3)
              setChunkData(chunked3)
              setPageData2(result2.data)
            }

            const result3 = await postData("/lead-content/details", {
              slug: 'number-intro4'
            });

            if (Array.isArray(result3.data.content)) {
              setLastChunkData(result3.data.content)
              setPageData3(result3.data)
            }


          }
        }
        if (type === 6) {
          const intro6 = await postData("/lead-content/details", {
            slug: 'leader-say-intro6'
          });

          setPageData(intro6.data);

          const intro62 = await postData("/lead-content/details", {
            slug: 'succssion-planing-intro6'
          });

          setPageData2(intro62.data);

          const intro63 = await postData("/lead-content/details", {
            slug: 'number-intro6'
          });

          setPageData3(intro63.data);
        }

      } catch (err) {
        console.log(err.message);
      }
    };
    loadPageDetails();
  }, []);




  return (
    <>
      {type === 4 && (
        <>
          <section className="relative w-full bg-white py-10 lg:py-16 xl:py-20 z-0 overflow-hidden border-b border-slate-100">
            <div className={"mb-10 lg:mb-20 flex items-center justify-center max-w-[1160px] mx-auto"}>
              <Link to={'/'}>
                <div className={"h-14 sm:h-20 w-full flex justify-center object-contain mb-5"}>
                  <svg className="h-full" preserveAspectRatio="xMidYMid meet" data-bbox="0 0 382.89 71.37" viewBox="0 0 382.89 71.37" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" aria-labelledby="svgcid-iz595q-x7t6i4"><title id="svgcid-iz595q-x7t6i4">SuccessionNow Logo</title><g><path d="m21.02 40.95-6.88-2.98c-3.78-1.61-4.59-3.29-4.59-6.01s1.05-5.15 5.08-5.15c3.41 0 4.84 2.42 4.84 6.57h8.56v-1.24c0-8.49-5.77-11.9-13.7-11.9-8.44 0-13.71 4.4-13.71 13.02 0 7.38 3.66 10.66 11.59 13.39 5.89 2.05 7.94 3.53 7.94 7.56 0 3.72-2.6 5.46-5.33 5.46-4.71 0-5.89-2.67-5.89-6.82v-1.3H0v1.8c0 8.18 3.97 12.9 14.07 12.9s15.38-4.22 15.38-13.58c0-5.39-1.74-8.8-8.43-11.72Z" fill="#3a8078" data-color="1"></path><path d="M49.45 54.15c0 3.72-1.61 5.52-4.53 5.52-2.54 0-3.66-1.3-3.66-4.65v-23H32.7v24.74c0 6.57 3.16 9.49 8.49 9.49 3.6 0 6.7-1.49 8.49-4.77h.12v3.91h8.18V32.02h-8.56v22.13Z" fill="#3a8078" data-color="1"></path><path d="M75.18 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M103.19 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M131.01 31.15c-11.53 0-13.27 8.31-13.27 17.24 0 8.31.5 17.85 12.9 17.85 8.06 0 11.78-4.34 12.09-12.09h-7.69c-.5 4.09-1.67 6.26-4.53 6.26-3.16 0-4.22-3.84-4.22-7.75v-2.67h16.92v-1.92c0-10.23-2.23-16.93-12.21-16.93Zm-4.71 13.76v-1.3c0-3.1.99-6.63 4.4-6.63s4.15 2.85 4.34 7.94h-8.74Z" fill="#3a8078" data-color="1"></path><path d="m162.72 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path d="m189.75 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path fill="#3a8078" d="M209.32 20.61v7.32h-8.56v-7.32h8.56z" data-color="1"></path><path fill="#3a8078" d="M209.32 32.02v33.35h-8.56V32.02h8.56z" data-color="1"></path><path d="M226.36 31.15c-9.8 0-13.14 6.14-13.14 17.54s2.85 17.73 13.14 17.55c9.8 0 13.14-6.14 13.14-17.55s-2.85-17.73-13.14-17.54Zm0 29.26c-4.22 0-4.59-4.9-4.59-11.72s.37-11.72 4.59-11.72c3.47 0 4.59 3.41 4.59 11.72s-1.12 11.72-4.59 11.72Z" fill="#3a8078" data-color="1"></path><path d="M260 31.15c-3.6 0-6.7 1.49-8.49 4.77h-.12v-3.91h-8.18v33.35h8.56V43.23c0-3.72 1.61-5.52 4.53-5.52 2.54 0 3.66 1.3 3.66 4.65v23h8.56V40.62c0-6.57-3.16-9.49-8.49-9.49Z" fill="#3a8078" data-color="1"></path><path d="M325.74 31.15c-9.8 0-14.45 6.14-16.86 17.54-2.48 11.59-.93 17.73 9.42 17.55 9.79 0 14.45-6.14 16.86-17.55 2.48-11.59.93-17.73-9.42-17.54Zm.87 17.54c-1.74 8.31-3.6 11.72-7.07 11.72-4.21 0-3.53-4.9-2.11-11.72 1.49-6.82 2.85-11.72 7.07-11.72 3.47 0 3.91 3.41 2.11 11.72Z" fill="#a7a9ac" data-color="2"></path><path fill="#a7a9ac" d="m374.7 32.02-9.05 23.68h-.12l.62-23.68h-9.3l-9.18 23.68h-.12l1.11-23.68h-8.55l.18 33.35h9.92l9.18-23.68h.12l-.62 23.68h9.74l14.26-33.35h-8.19z" data-color="2"></path><path fill="#a7a9ac" d="M321.29 12.82 313.02 0 300.2 8.27l6.29 1.36-11.16 41.79h-.13l-5.34-23.31h-10.29l-9.42 43.26h8.18l6.57-29.99h.13l5.34 23.99h10.16l14.2-53.96 6.56 1.41z" data-color="2"></path></g></svg>
                </div>
              </Link>
            </div>
            <div className="absolute z-[-1] w-full h-full top-0 left-0 opacity-75 after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0">
              <Image src={Background} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
            </div>
            <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
              <div className="space-y-12">
                <div className="relative space-y-5">
                  <h2 className="xl:text-4xl text-3xl font-bold text-dark-teal-400 tracking-tight">{pageData.description}</h2>
                  <div className="grid sm:grid-cols-3 gap-4 lg:gap-8">
                    {Array.isArray(firstChunk) && firstChunk.map((it, i) => {
                      return (
                        <div className="relative flex">
                          <div className="w-full justify-between flex  flex-col bg-white border border-slate-200 rounded px-6 py-10">
                            <div className="space-y-2 flex flex-col justify-between text-slate-600 leading-tight text-sm xl:text-base">{it.title}</div>
                            <div className="text-xs xl:text-sm text-slate-500 mt-1">{it.creator}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="!mt-10 flex justify-center">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={"View the Demo"}
                      buttonLabelClasses={"!text-xl"}
                      buttonClasses={"!h-12 !px-10 hover:!bg-teal-600"}
                      functions={() => { setScheduleDemoPopup(true) }}
                    />
                  </div>
                </div>
                <div className="relative space-y-5">
                  <div className="grid sm:grid-cols-3 gap-4 lg:gap-8">
                    {Array.isArray(secondChunk) && secondChunk.map((it, i) => {
                      return (
                        <div className="relative flex">
                          <div className="w-full justify-between flex  flex-col bg-white border border-slate-200 rounded px-6 py-10">
                            <div className="space-y-2 flex flex-col justify-between text-slate-600 leading-tight text-sm xl:text-base">{it.title}</div>
                            <div className="text-xs xl:text-sm text-slate-500 mt-1">{it.creator}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="!mt-10 flex justify-center">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={"View the Demo"}
                      buttonLabelClasses={"!text-xl"}
                      buttonClasses={"!h-12 !px-10 hover:!bg-teal-600"}
                      functions={() => { setScheduleDemoPopup(true)}}
                    />
                  </div>
                </div>
                <div className="relative space-y-5">
                  <h2 className="xl:text-4xl text-3xl font-bold text-dark-teal-400 tracking-tight">{pageData2.description}</h2>
                  <div className="grid sm:grid-cols-3 gap-4 lg:gap-8">
                    <div className="relative flex">
                      <div className="w-full flex bg-white border border-slate-200 rounded px-6 py-10">
                        <div className="space-y-3 flex flex-col justify-between">
                          <div className="text-base text-slate-900 uppercase font-semibold">Continuity</div>
                          <div className="space-y-1">
                            {Array.isArray(chunkValue[0]) && chunkValue[0].map((it, i) => {
                              return (<div className="text-sm xl:text-base text-slate-500">{it.title}</div>);
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="relative flex">
                      <div className="w-full flex bg-white border border-slate-200 rounded px-6 py-10">
                        <div className="space-y-3 flex flex-col justify-between">
                          <div className="text-base text-slate-900 uppercase font-semibold">Employee Retention</div>
                          <div className="space-y-1">
                            {Array.isArray(chunkValue[1]) && chunkValue[1].map((it, i) => {
                              return (<div className="text-sm xl:text-base text-slate-500">{it.title}</div>);
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="relative flex">
                      <div className="w-full flex bg-white border border-slate-200 rounded px-6 py-10">
                        <div className="space-y-3 flex flex-col justify-between">
                          <div className="text-base text-slate-900 uppercase font-semibold">Growth</div>
                          <div className="space-y-1">
                            {Array.isArray(chunkValue[2]) && chunkValue[2].map((it, i) => {
                              return (<div className="text-sm xl:text-base text-slate-500">{it.title}</div>);
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="!mt-10 flex justify-center">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={"View the Demo"}
                      buttonLabelClasses={"!text-xl"}
                      buttonClasses={"!h-12 !px-10 hover:!bg-teal-600"}
                      functions={() => { setScheduleDemoPopup(true) }}
                    />
                  </div>
                </div>
                <div className="relative space-y-5">
                  <h2 className="xl:text-4xl text-3xl font-bold text-dark-teal-400 tracking-tight">{pageData3.description}</h2>
                  <div className="grid sm:grid-cols-3 gap-4 lg:gap-8">
                    {Array.isArray(lastchunkValue) && lastchunkValue.map((it, i) => {
                      return (
                        <div className="relative flex">
                          <div className="w-full justify-between flex  flex-col bg-white border border-slate-200 rounded px-6 py-10">
                            <div className="space-y-2 flex flex-col text-slate-600 justify-between leading-tight text-sm xl:text-base">{it.title}</div>
                            <div className="text-xs xl:text-sm text-slate-500 mt-1">{it.creator}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="!mt-10 flex justify-center">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={"View the Demo"}
                      buttonLabelClasses={"!text-xl"}
                      buttonClasses={"!h-12 !px-10 hover:!bg-teal-600"}
                      functions={() => { setScheduleDemoPopup(true) }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          { scheduleDemoPopup &&
            <SchedualeDemoPopup
              isOpen={scheduleDemoPopup}
              setIsOpen={(val) => setScheduleDemoPopup(val)}
              data={''}
              getActionValue={(obj) => {
                // setActionValue(obj);
                // setIsUpdate(true);
              }}
            ></SchedualeDemoPopup>
          }
        </>
      )
      }
      {type === 6 && (
        <section className="relative w-full bg-white py-10 lg:py-16 xl:py-20 z-0 overflow-hidden border-b border-slate-100">
          <div className={"mb-10 lg:mb-20 flex items-center justify-center max-w-[1160px] mx-auto"}>
            <Link to={'/'}>
              <div className={"h-14 sm:h-20 w-full flex justify-center object-contain mb-5"}>
                <svg className="h-full" preserveAspectRatio="xMidYMid meet" data-bbox="0 0 382.89 71.37" viewBox="0 0 382.89 71.37" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" aria-labelledby="svgcid-iz595q-x7t6i4"><title id="svgcid-iz595q-x7t6i4">SuccessionNow Logo</title><g><path d="m21.02 40.95-6.88-2.98c-3.78-1.61-4.59-3.29-4.59-6.01s1.05-5.15 5.08-5.15c3.41 0 4.84 2.42 4.84 6.57h8.56v-1.24c0-8.49-5.77-11.9-13.7-11.9-8.44 0-13.71 4.4-13.71 13.02 0 7.38 3.66 10.66 11.59 13.39 5.89 2.05 7.94 3.53 7.94 7.56 0 3.72-2.6 5.46-5.33 5.46-4.71 0-5.89-2.67-5.89-6.82v-1.3H0v1.8c0 8.18 3.97 12.9 14.07 12.9s15.38-4.22 15.38-13.58c0-5.39-1.74-8.8-8.43-11.72Z" fill="#3a8078" data-color="1"></path><path d="M49.45 54.15c0 3.72-1.61 5.52-4.53 5.52-2.54 0-3.66-1.3-3.66-4.65v-23H32.7v24.74c0 6.57 3.16 9.49 8.49 9.49 3.6 0 6.7-1.49 8.49-4.77h.12v3.91h8.18V32.02h-8.56v22.13Z" fill="#3a8078" data-color="1"></path><path d="M75.18 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M103.19 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M131.01 31.15c-11.53 0-13.27 8.31-13.27 17.24 0 8.31.5 17.85 12.9 17.85 8.06 0 11.78-4.34 12.09-12.09h-7.69c-.5 4.09-1.67 6.26-4.53 6.26-3.16 0-4.22-3.84-4.22-7.75v-2.67h16.92v-1.92c0-10.23-2.23-16.93-12.21-16.93Zm-4.71 13.76v-1.3c0-3.1.99-6.63 4.4-6.63s4.15 2.85 4.34 7.94h-8.74Z" fill="#3a8078" data-color="1"></path><path d="m162.72 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path d="m189.75 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path fill="#3a8078" d="M209.32 20.61v7.32h-8.56v-7.32h8.56z" data-color="1"></path><path fill="#3a8078" d="M209.32 32.02v33.35h-8.56V32.02h8.56z" data-color="1"></path><path d="M226.36 31.15c-9.8 0-13.14 6.14-13.14 17.54s2.85 17.73 13.14 17.55c9.8 0 13.14-6.14 13.14-17.55s-2.85-17.73-13.14-17.54Zm0 29.26c-4.22 0-4.59-4.9-4.59-11.72s.37-11.72 4.59-11.72c3.47 0 4.59 3.41 4.59 11.72s-1.12 11.72-4.59 11.72Z" fill="#3a8078" data-color="1"></path><path d="M260 31.15c-3.6 0-6.7 1.49-8.49 4.77h-.12v-3.91h-8.18v33.35h8.56V43.23c0-3.72 1.61-5.52 4.53-5.52 2.54 0 3.66 1.3 3.66 4.65v23h8.56V40.62c0-6.57-3.16-9.49-8.49-9.49Z" fill="#3a8078" data-color="1"></path><path d="M325.74 31.15c-9.8 0-14.45 6.14-16.86 17.54-2.48 11.59-.93 17.73 9.42 17.55 9.79 0 14.45-6.14 16.86-17.55 2.48-11.59.93-17.73-9.42-17.54Zm.87 17.54c-1.74 8.31-3.6 11.72-7.07 11.72-4.21 0-3.53-4.9-2.11-11.72 1.49-6.82 2.85-11.72 7.07-11.72 3.47 0 3.91 3.41 2.11 11.72Z" fill="#a7a9ac" data-color="2"></path><path fill="#a7a9ac" d="m374.7 32.02-9.05 23.68h-.12l.62-23.68h-9.3l-9.18 23.68h-.12l1.11-23.68h-8.55l.18 33.35h9.92l9.18-23.68h.12l-.62 23.68h9.74l14.26-33.35h-8.19z" data-color="2"></path><path fill="#a7a9ac" d="M321.29 12.82 313.02 0 300.2 8.27l6.29 1.36-11.16 41.79h-.13l-5.34-23.31h-10.29l-9.42 43.26h8.18l6.57-29.99h.13l5.34 23.99h10.16l14.2-53.96 6.56 1.41z" data-color="2"></path></g></svg>
              </div>
            </Link>
          </div>
          <div className="absolute z-[-1] w-full h-full top-0 left-0 opacity-75 after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0">
            <Image src={Background} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
          </div>
          <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
            <div className="flex justify-center flex-wrap lg:flex-nowrap gap-10 xl:gap-20 2xl:gap-32">
              <div className="w-full">
                <div className="relative space-y-4 lg:space-y-10">
                  <h2 className="mb-3 lg:mb-6 block text-xl sm:text-2xl xl:text-3xl 3xl:text-4xl font-bold text-dark-teal-400 tracking-tight">{pageData.description}</h2>
                  <ul className="pl-8 space-y-5">
                    {(pageData?.content && pageData?.content.length > 0) && pageData?.content.map((item, index) => (
                      <li key={index} className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8">
                        <span className="flex leading-tight text-sm xl:text-base">{item?.title}</span>
                        <span className="flex justify-end text-xs text-slate-400 font-normal mt-1">- {item?.creator}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="w-full">
                <div className="relative space-y-4 lg:space-y-10">
                  <h2 className="mb-3 lg:mb-6 block text-xl sm:text-2xl xl:text-3xl 3xl:text-4xl font-bold text-dark-teal-400 tracking-tight">{pageData2.description}</h2>
                  <ul className="pl-8 space-y-5">
                    {(pageData2?.content && pageData2?.content.length > 0) && pageData2?.content.map((item, index) => (
                      <li key={index} className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8">
                        <span className="flex leading-tight">{item?.title}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="w-full">
                <div className="relative space-y-4 lg:space-y-10">
                  <h2 className="mb-3 lg:mb-6 block text-xl sm:text-2xl xl:text-3xl 3xl:text-4xl font-bold text-dark-teal-400 tracking-tight">{pageData3.description}</h2>
                  <ul className="pl-8 space-y-5">
                    {(pageData3?.content && pageData3?.content.length > 0) &&
                      pageData3?.content.map((item, index) => (
                        <li key={index} className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8">
                          <span className="flex leading-tight">{item?.title}</span>
                          <span className="flex justify-end text-xs text-slate-400 font-normal">- {item?.creator}</span>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto mt-20">
            <div className="flex justify-center flex-wrap lg:flex-nowrap gap-10 xl:gap-20 2xl:gap-32">
              <div className="w-full lg:w-1/2 xl:w-5/12">
                <div className="relative space-y-10">
                  <div className="space-y-4">
                    <h2 className="xl:text-5xl text-3xl font-bold text-dark-teal-400 tracking-tight">View Demo</h2>
                    <h4 className="text-lg text-black leading-tight">See why SuccessionNow is the #1 succession planning software.</h4>
                  </div>
                  <div className="relative space-y-5">
                    <div className="relative">
                      <Input
                        labelClasses={"!text-white font-light"}
                        inputType={"text"}
                        inputClasses={
                          "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                        }
                        inputPlaceholder={"Full Name"}
                        inputValue={fullName}
                        inputName={""}
                        errorType={""}
                        isDisabled={false}
                        setInput={setFullName}
                      />
                    </div>
                    <div className="relative">
                      <Input
                        labelClasses={"!text-white font-light"}
                        inputType={"email"}
                        inputClasses={
                          "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                        }
                        inputPlaceholder={"Work Email"}
                        inputValue={email}
                        inputName={""}
                        errorType={""}
                        setInput={setEmail}
                      />
                    </div>
                    <div className="relative">
                      <Input
                        labelClasses={"!text-white font-light"}
                        inputType={"text"}
                        inputClasses={
                          "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                        }
                        inputPlaceholder={"Phone Number"}
                        inputValue={phone}
                        inputName={""}
                        errorType={""}
                        setInput={setPhone}
                      />
                    </div>
                    <div className="relative md:col-span-2">
                      <div className="flex justify-center mt-8">
                        <Button
                          buttonClasses="!bg-dark-teal-700 hover:!bg-dark-teal-900 !px-6 !w-full !h-14 !text-xl rounded-lg"
                          buttonLabelClasses="!text-xl"
                          buttonType={"button"}
                          buttonLabel={"View Demo"}
                          buttonIcon={
                            loading
                              ? "fa-light fa-spinner fa-spin"
                              : ""
                          }
                          buttonIconPosition={"left"}
                          functions={handelSubmit}
                          buttonHasLink={false}
                          buttonDisabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="h-40 sm:h-72 md:h-96 lg:h-[440px] flex">
            <div className="absolute w-full max-w-[1024px] px-6 xl:px-0 bottom-0 left-1/2 -translate-x-1/2 flex">
              <div className="absolute z-[1] w-full h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-solid fa-play"}
                  buttonIconPosition={"left"}
                  buttonClasses={"!w-16 !h-16 !p-0 !rounded-full !text-3xl !mt-16 hover:!bg-teal-600 !shadow-lg"}
                  functions={() => { }}
                />
              </div>
              <Image src={Screenshot} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
            </div>
          </div>
        </section>
      )}
      {type !== 4 && type !== 6 && (
        <>
          <section className="relative w-full bg-white py-10 lg:py-16 xl:py-20 z-0 overflow-hidden border-b border-slate-100">
            <div className={"mb-10 lg:mb-20 flex items-center justify-center max-w-[1160px] mx-auto"}>
              <Link to={'/'}>
                <div className={"h-14 sm:h-20 w-full flex justify-center object-contain mb-5"}>
                  <svg className="h-full" preserveAspectRatio="xMidYMid meet" data-bbox="0 0 382.89 71.37" viewBox="0 0 382.89 71.37" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" aria-labelledby="svgcid-iz595q-x7t6i4"><title id="svgcid-iz595q-x7t6i4">SuccessionNow Logo</title><g><path d="m21.02 40.95-6.88-2.98c-3.78-1.61-4.59-3.29-4.59-6.01s1.05-5.15 5.08-5.15c3.41 0 4.84 2.42 4.84 6.57h8.56v-1.24c0-8.49-5.77-11.9-13.7-11.9-8.44 0-13.71 4.4-13.71 13.02 0 7.38 3.66 10.66 11.59 13.39 5.89 2.05 7.94 3.53 7.94 7.56 0 3.72-2.6 5.46-5.33 5.46-4.71 0-5.89-2.67-5.89-6.82v-1.3H0v1.8c0 8.18 3.97 12.9 14.07 12.9s15.38-4.22 15.38-13.58c0-5.39-1.74-8.8-8.43-11.72Z" fill="#3a8078" data-color="1"></path><path d="M49.45 54.15c0 3.72-1.61 5.52-4.53 5.52-2.54 0-3.66-1.3-3.66-4.65v-23H32.7v24.74c0 6.57 3.16 9.49 8.49 9.49 3.6 0 6.7-1.49 8.49-4.77h.12v3.91h8.18V32.02h-8.56v22.13Z" fill="#3a8078" data-color="1"></path><path d="M75.18 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M103.19 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M131.01 31.15c-11.53 0-13.27 8.31-13.27 17.24 0 8.31.5 17.85 12.9 17.85 8.06 0 11.78-4.34 12.09-12.09h-7.69c-.5 4.09-1.67 6.26-4.53 6.26-3.16 0-4.22-3.84-4.22-7.75v-2.67h16.92v-1.92c0-10.23-2.23-16.93-12.21-16.93Zm-4.71 13.76v-1.3c0-3.1.99-6.63 4.4-6.63s4.15 2.85 4.34 7.94h-8.74Z" fill="#3a8078" data-color="1"></path><path d="m162.72 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path d="m189.75 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path fill="#3a8078" d="M209.32 20.61v7.32h-8.56v-7.32h8.56z" data-color="1"></path><path fill="#3a8078" d="M209.32 32.02v33.35h-8.56V32.02h8.56z" data-color="1"></path><path d="M226.36 31.15c-9.8 0-13.14 6.14-13.14 17.54s2.85 17.73 13.14 17.55c9.8 0 13.14-6.14 13.14-17.55s-2.85-17.73-13.14-17.54Zm0 29.26c-4.22 0-4.59-4.9-4.59-11.72s.37-11.72 4.59-11.72c3.47 0 4.59 3.41 4.59 11.72s-1.12 11.72-4.59 11.72Z" fill="#3a8078" data-color="1"></path><path d="M260 31.15c-3.6 0-6.7 1.49-8.49 4.77h-.12v-3.91h-8.18v33.35h8.56V43.23c0-3.72 1.61-5.52 4.53-5.52 2.54 0 3.66 1.3 3.66 4.65v23h8.56V40.62c0-6.57-3.16-9.49-8.49-9.49Z" fill="#3a8078" data-color="1"></path><path d="M325.74 31.15c-9.8 0-14.45 6.14-16.86 17.54-2.48 11.59-.93 17.73 9.42 17.55 9.79 0 14.45-6.14 16.86-17.55 2.48-11.59.93-17.73-9.42-17.54Zm.87 17.54c-1.74 8.31-3.6 11.72-7.07 11.72-4.21 0-3.53-4.9-2.11-11.72 1.49-6.82 2.85-11.72 7.07-11.72 3.47 0 3.91 3.41 2.11 11.72Z" fill="#a7a9ac" data-color="2"></path><path fill="#a7a9ac" d="m374.7 32.02-9.05 23.68h-.12l.62-23.68h-9.3l-9.18 23.68h-.12l1.11-23.68h-8.55l.18 33.35h9.92l9.18-23.68h.12l-.62 23.68h9.74l14.26-33.35h-8.19z" data-color="2"></path><path fill="#a7a9ac" d="M321.29 12.82 313.02 0 300.2 8.27l6.29 1.36-11.16 41.79h-.13l-5.34-23.31h-10.29l-9.42 43.26h8.18l6.57-29.99h.13l5.34 23.99h10.16l14.2-53.96 6.56 1.41z" data-color="2"></path></g></svg>
                </div>
              </Link>
            </div>
            <div className="absolute z-[-1] w-full h-full top-0 left-0 opacity-75 after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0">
              <Image src={Background} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
            </div>
            <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
              <div className="flex justify-center flex-wrap lg:flex-nowrap gap-10 xl:gap-20 2xl:gap-32">
                <div className="w-full lg:w-1/2 xl:w-5/12">
                  <div className="relative w-full max-w-md lg:max-w-none mx-auto space-y-10">
                    <div className="space-y-4">
                      <h2 className="xl:text-5xl text-3xl font-bold text-dark-teal-400 tracking-tight">View Demo</h2>
                      <h4 className="text-lg text-black leading-tight">See why SuccessionNow is the #1 succession planning software.</h4>
                    </div>
                    <div className="relative space-y-5">
                      <div className="relative">
                        <Input
                          labelClasses={"!text-white font-light"}
                          inputType={"text"}
                          inputClasses={
                            "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                          }
                          inputPlaceholder={"Full Name"}
                          inputValue={fullName}
                          inputName={""}
                          errorType={""}
                          isDisabled={false}
                          setInput={setFullName}
                        />
                      </div>
                      <div className="relative">
                        <Input
                          labelClasses={"!text-white font-light"}
                          inputType={"email"}
                          inputClasses={
                            "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                          }
                          inputPlaceholder={"Work Email"}
                          inputValue={email}
                          inputName={""}
                          errorType={""}
                          setInput={setEmail}
                        />
                      </div>
                      <div className="relative">
                        <Input
                          labelClasses={"!text-white font-light"}
                          inputType={"text"}
                          inputClasses={
                            "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                          }
                          inputPlaceholder={"Phone Number"}
                          inputValue={phone}
                          inputName={""}
                          errorType={""}
                          setInput={setPhone}
                        />
                      </div>
                      <div className="relative md:col-span-2">
                        <div className="flex justify-center mt-8">
                          <Button
                            buttonClasses="!bg-dark-teal-700 hover:!bg-dark-teal-900 !px-6 !w-full !h-14 !text-xl rounded-lg"
                            buttonLabelClasses="!text-xl"
                            buttonType={"button"}
                            buttonLabel={"View Demo"}
                            buttonIcon={
                              loading
                                ? "fa-light fa-spinner fa-spin"
                                : ""
                            }
                            buttonIconPosition={"left"}
                            functions={handelSubmit}
                            buttonHasLink={false}
                            buttonDisabled={loading}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full lg:w-1/2 xl:w-5/12">
                  <div className="relative space-y-10">
                    <h2 className="mb-6 block text-3xl xl:text-5xl 2xl:text-6xl font-bold text-dark-teal-400 tracking-tight">
                      {(pageData?.description) ? pageData?.description : ''}
                    </h2>
                    { (type && type === 2) &&
                      <ul className="pl-8 space-y-5">
                        {(pageData?.content && pageData?.content.length > 0) &&
                          pageData?.content.map((item, index) => (
                            <li key={index} className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8">
                              <span className="flex leading-tight text-sm xl:text-base">{item?.title}</span>
                              <span className="flex justify-end text-xs text-slate-400 font-normal mt-1">- {item?.creator}</span>
                            </li>
                          ))
                        }
                      </ul>
                    }
                    {(type && type === 3) &&
                      <ul className="pl-8 grid grid-cols-2 gap-y-5 gap-x-10">
                        {(pageData?.content && pageData?.content.length > 0) &&
                          pageData?.content.map((item, index) => (
                            <li key={index} className="relative font-semibold text-sm xl:text-base text-black leading-tight before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:-top-[3px] before:-left-8">{item?.title}</li>
                          ))
                        }
                      </ul>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="h-40 sm:h-72 md:h-96 lg:h-[440px] flex">
              <div className="absolute w-full max-w-[1024px] px-6 xl:px-0 bottom-0 left-1/2 -translate-x-1/2 flex">
                <div className="absolute z-[1] w-full h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
                  <Button
                    buttonHasLink={false}
                    buttonIcon={"fa-solid fa-play"}
                    buttonIconPosition={"left"}
                    buttonClasses={"!w-16 !h-16 !p-0 !rounded-full !text-3xl !mt-16 hover:!bg-teal-600 !shadow-lg"}
                    functions={() => { }}
                  />
                </div>
                <Image src={Screenshot} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
              </div>
            </div>
          </section>
        </>
      )
      }

    </>
  );
};

export default IntroContent;